var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22.5,
    stroke: "#898989"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3316 17.2223C16.0929 17.3266 15.1566 18.4058 15.0963 19.7355C15.0467 20.831 15 22.0917 15 22.962C15 23.8423 15.0477 25.1219 15.0981 26.2261C15.1579 27.5388 16.0727 28.6108 17.2941 28.7316C18.6462 28.8654 20.6025 29 23 29C25.3912 29 27.3436 28.8661 28.6953 28.7327C29.9215 28.6116 30.8381 27.5327 30.8971 26.2149C30.9492 25.0523 31 23.7221 31 22.962C31 22.2101 30.9502 20.9002 30.8988 19.7466C30.8393 18.4118 29.9015 17.3259 28.6581 17.2215C27.3272 17.1097 25.4076 17 23 17C20.5862 17 18.6629 17.1103 17.3316 17.2223ZM21.4 20.4177L25.5244 22.962L21.4 25.5063V20.4177Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/youTube.b4f3ea866266a343f0e100e1a6898c0a.svg";
export { ForwardRef as ReactComponent };